import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { Menu, Modal, SaveButton, useIsAdmin, useModalConfirm, usePermissions } from 'components';
import AddProductToList from 'components/layout/AddProductToList';
import { notifyApiError } from 'components/layout/Toasts';

import { OfferCatalogApi } from 'src/api';
import { userPermissions } from 'src/constants/enums';

import { refreshValuations } from '../../../../actions';
import SupplierThumbnail from '../../../SupplierThumbnail';

import style from './ProductMenu.module.scss';

const ProductMenu = ({ product, selectedCompany }) => {
  const isAdmin = useIsAdmin();
  const dispatch = useDispatch();
  const [renderedModalConfirm, handleOpenModalConfirm] = useModalConfirm();
  const [isOpen, setIsOpen] = useState(false);
  const [isModalAddToListOpen, setIsModalAddToListOpen] = useState(false);
  const [canMenageCatalog] = usePermissions([userPermissions.offer_catalog.menage]);

  const deleteProduct = async () => {
    const data = {
      product_id: product.product_id,
      ...(isAdmin && { company_id: selectedCompany })
    };

    try {
      await OfferCatalogApi.deleteProduct(data);
      dispatch(refreshValuations());
    } catch (err) {
      notifyApiError(err);
    }
  };

  const deletePrice = async (id) => {
    const data = {
      id,
      ...(isAdmin && { company_id: selectedCompany })
    };

    try {
      await OfferCatalogApi.deleteSinglePrice(data);
      dispatch(refreshValuations());
    } catch (err) {
      notifyApiError(err);
    }
  };

  const deleteProductHandler = () => {
    handleOpenModalConfirm({
      message: 'Na pewno chcesz usunąć product z katalogu?',
      handleConfirm: deleteProduct,
      cancelButtonName: 'Nie',
      confirmButtonName: 'Tak'
    });
  };

  const actions = [
    {
      title: 'Dodaj do listy',
      icon: 'add',
      action: () => setIsModalAddToListOpen(true)
    },
    {
      title: 'Usuń wybraną cenę',
      icon: 'trash',
      color: 'blue',
      action: () => setIsOpen(true),
      roles: canMenageCatalog ? ['user', 'admin'] : ['admin']
    },
    {
      title: 'Usuń produkt z katalogu',
      icon: 'trash',
      color: 'red',
      action: deleteProductHandler,
      roles: canMenageCatalog ? ['user', 'admin'] : ['admin']
    }
  ];

  return (
    <>
      <Menu
        actions={actions}
        className={style.menu}
      />
      {renderedModalConfirm}
      <Modal
        visible={isOpen}
        onClose={() => setIsOpen(false)}
        title={'Usuń wybraną cenę'}
      >
        <div className={style.wrapper}>
          {product.prices.map((price) => (
            <SupplierThumbnail
              key={price.id}
              item={price}
            >
              <SaveButton
                type={'delete'}
                onClick={() => deletePrice(price.id)}
              />
            </SupplierThumbnail>
          ))}
        </div>
      </Modal>
      <AddProductToList
        title={`Dodaj "${product.name}" do listy`}
        visible={isModalAddToListOpen}
        onClose={() => setIsModalAddToListOpen(false)}
        productId={product.product_id}
      />
    </>
  );
};

export default ProductMenu;
